export default __webpack_public_path__ + "static/media/home.81741049.jpg";